// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/chats/chat_type.proto (package protos.entities.app.chats, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file entities/app/chats/chat_type.proto.
 */
export const file_entities_app_chats_chat_type: GenFile = /*@__PURE__*/
  fileDesc("CiJlbnRpdGllcy9hcHAvY2hhdHMvY2hhdF90eXBlLnByb3RvEhlwcm90b3MuZW50aXRpZXMuYXBwLmNoYXRzKl8KCENoYXRUeXBlEhUKEUNIQVRfVFlQRV9VTktOT1dOEAASFAoQQ0hBVF9UWVBFX0RJUkVDVBABEhMKD0NIQVRfVFlQRV9HUk9VUBACEhEKDUNIQVRfVFlQRV9KT0IQA2IGcHJvdG8z");

/**
 * @generated from enum protos.entities.app.chats.ChatType
 */
export enum ChatType {
  /**
   * @generated from enum value: CHAT_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CHAT_TYPE_DIRECT = 1;
   */
  DIRECT = 1,

  /**
   * @generated from enum value: CHAT_TYPE_GROUP = 2;
   */
  GROUP = 2,

  /**
   * @generated from enum value: CHAT_TYPE_JOB = 3;
   */
  JOB = 3,
}

/**
 * Describes the enum protos.entities.app.chats.ChatType.
 */
export const ChatTypeSchema: GenEnum<ChatType> = /*@__PURE__*/
  enumDesc(file_entities_app_chats_chat_type, 0);

